/** @typedef {'poker' | 'gaming-machines' | 'restaurants'} PromotionCategorySlug */

/** Canonical Payload category slugs. */
export const PROMOTION_CATEGORY_SLUGS = /** @type {const} */ ([
  "poker",
  "gaming-machines",
  "restaurants",
]);

/**
 * Maps public URL :category segment (EN or FR path) → Payload slug.
 * PGCA owns localized paths; Payload stores stable slugs only.
 * @type {Record<string, PromotionCategorySlug>}
 */
const ROUTE_CATEGORY_TO_SLUG = {
  poker: "poker",
  "gaming-machines": "gaming-machines",
  "machines-de-jeu": "gaming-machines",
  "restaurants": "restaurants",
};

/** Legacy ERS / CSV label → slug (hub cards from JSON until fully migrated). */
const LEGACY_CATEGORY_ALIASES = {
  "Poker Promotions": "poker",
  "Gaming Machine Promotions": "gaming-machines",
  "Restaurant Promotions": "restaurants",
  "Promotions poker": "poker",
  "Promotions machines de jeu": "gaming-machines",
  "Promotions restaurants": "restaurants",
};

/**
 * @param {string | undefined} routeCategory - `params.category` from react-router
 * @returns {PromotionCategorySlug | undefined}
 */
export function routeCategoryToSlug(routeCategory) {
  if (!routeCategory) return undefined;
  const trimmed = routeCategory.trim();
  if (PROMOTION_CATEGORY_SLUGS.includes(/** @type {PromotionCategorySlug} */ (trimmed))) {
    return /** @type {PromotionCategorySlug} */ (trimmed);
  }
  return ROUTE_CATEGORY_TO_SLUG[trimmed];
}

/**
 * @param {string | undefined} raw - Slug or legacy translated label
 * @returns {PromotionCategorySlug | undefined}
 */
export function normalizePromotionCategory(raw) {
  if (!raw) return undefined;
  const trimmed = raw.trim();
  if (PROMOTION_CATEGORY_SLUGS.includes(/** @type {PromotionCategorySlug} */ (trimmed))) {
    return /** @type {PromotionCategorySlug} */ (trimmed);
  }
  return LEGACY_CATEGORY_ALIASES[trimmed];
}

/**
 * @param {string | undefined} routeCategory
 * @param {string | undefined} cardCategory
 * @returns {boolean}
 */
export function promotionCategoryMatchesRoute(routeCategory, cardCategory) {
  const routeSlug = routeCategoryToSlug(routeCategory);
  const cardSlug = normalizePromotionCategory(cardCategory);
  if (!routeSlug) return true;
  if (!cardSlug) return false;
  return routeSlug === cardSlug;
}
